module.exports = __webpack_public_path__ + "static/media/Projet-Villa-Vaud.2c0b5095.jpg";